import React from 'react'
import { FormattedMessage } from 'react-intl'

import { InlineWarningBanner } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/inlineWarningBanner/InlineWarningBanner'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

import { OVERDUE_TASK_THRESHOLD_DAYS } from '../constants'

type InvoiceDeadlineBannerProps = {
  count: number
}

export const InvoiceDeadlineBanner: React.FC<InvoiceDeadlineBannerProps> = ({ count }) => (
  <InlineWarningBanner
    title={
      <FormattedMessage
        defaultMessage='{count, plural, one {# invoice} other {# invoices}} over {threshold} days old.'
        description='Banner title showing the number of overdue invoices'
        values={{ count, threshold: OVERDUE_TASK_THRESHOLD_DAYS }}
      />
    }
    text={
      <FormattedMessage
        defaultMessage='Invoices must be submitted within 90 days to be eligible for payment.'
        description='Banner reminder about the invoice submission deadline'
      />
    }
    testId={tID('TasksPanel-invoice-deadline-banner')}
    marginBottom='0px'
  />
)
